(function () {
	const storageKey = 'theme';
	const root = document.documentElement;

	function isValidTheme(theme) {
		return theme === 'light' || theme === 'dark';
	}

	function getSystemTheme() {
		if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
			return 'dark';
		}

		return 'light';
	}

	function getStoredTheme() {
		const storedTheme = window.localStorage.getItem(storageKey);

		if (isValidTheme(storedTheme)) {
			return storedTheme;
		}

		return null;
	}

	function applyTheme(theme, options) {
		const nextTheme = isValidTheme(theme) ? theme : getSystemTheme();
		const shouldStore = !options || options.store !== false;

		root.setAttribute('data-theme', nextTheme);
		updateToggleControls(nextTheme);

		if (shouldStore) {
			window.localStorage.setItem(storageKey, nextTheme);
		}

		return nextTheme;
	}

	function updateToggleControls(theme) {
		const isDark = theme === 'dark';
		const toggleControls = document.querySelectorAll('[data-theme-toggle]');

		Array.prototype.forEach.call(toggleControls, function (control) {
			control.setAttribute('aria-pressed', String(isDark));
			control.setAttribute(
				'aria-label',
				isDark ? 'Világos mód bekapcsolása' : 'Sötét mód bekapcsolása'
			);
		});
	}

	function bindToggleControls() {
		const toggleControls = document.querySelectorAll('[data-theme-toggle]');

		Array.prototype.forEach.call(toggleControls, function (control) {
			control.addEventListener('click', function () {
				const rootTheme = root.getAttribute('data-theme');
				const currentTheme = isValidTheme(rootTheme)
					? rootTheme
					: initTheme();

				applyTheme(currentTheme === 'dark' ? 'light' : 'dark');
			});
		});
	}

	function initTheme() {
		return applyTheme(getStoredTheme() || getSystemTheme(), {
			store: false,
		});
	}

	function initThemeToggle() {
		initTheme();
		bindToggleControls();
	}

	window.sechomeTheme = {
		apply: applyTheme,
		init: initTheme,
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initThemeToggle);
	} else {
		initThemeToggle();
	}
})();
